import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/userCoupons',
    component: Layout2,
    meta: {
        zhtitle: zh.m.aside.nav.COUPON_TABLE,
        jatitle: ja.m.aside.nav.COUPON_TABLE,
        pername: "coupons"
    },
    children: [{
        path: '',
        name: 'userCoupons',
        component: () => import( /* webpackChunkName: "jp.userCoupons" */ '@/merchanAdmin/userCoupons/list'),
        meta: {
            zhtitle: zh.m.aside.nav.COUPON_TABLE,
            jatitle: ja.m.aside.nav.COUPON_TABLE,
            pername: "coupons"
        }
    }],

}]
